import {
  ConfigDocuments,
  IBigQueryUploadsConfig,
  IDemoSpace,
  IPublicConfig,
  IRecaptchaConfig,
  RootCollection,
} from '@principle-theorem/principle-core/interfaces';
import { asDocRef, DocumentReference } from '@principle-theorem/shared';

export class RootConfig {
  static public(): DocumentReference<IPublicConfig> {
    return RootConfig.getDocRef<IPublicConfig>(ConfigDocuments.Public);
  }

  static demoSpace(): DocumentReference<IDemoSpace> {
    return RootConfig.getDocRef<IDemoSpace>(ConfigDocuments.DemoSpace);
  }

  static recaptcha(): DocumentReference<IRecaptchaConfig> {
    return RootConfig.getDocRef<IRecaptchaConfig>(ConfigDocuments.Recaptcha);
  }

  static bigQueryUploads(): DocumentReference<IBigQueryUploadsConfig> {
    return RootConfig.getDocRef<IBigQueryUploadsConfig>(
      ConfigDocuments.BigQueryUploads
    );
  }

  static getDocRef<T extends object>(
    docId: ConfigDocuments
  ): DocumentReference<T> {
    return asDocRef<T>(`${RootCollection.Configuration}/${docId}`);
  }
}
